



















import { Component, Prop, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { project, user } from "../board";
import moment from "moment";

@Component
export default class ProjectTeam extends Vue {
  @Action updateProject;
  @Prop() project!: project;
  private selectedUser: user = {
    _id: "",
    name: "",
    email: "",
    picture: "",
    token: "",
  };

  get cardDate() {
    if (this.project.createdOn) {
      const formattedDate = moment(this.project.createdOn.toString()).format(
        "MMM DD, YYYY"
      );
      return formattedDate;
    }
    return "";
  }

  addNewUserToProject() {
    if (
      this.project.users.findIndex((u) => u.token === this.selectedUser.token) <
      0
    ) {
      this.project.users.push(this.selectedUser);
      this.updateProject(this.project);
    }
  }
}
